import React, {useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import ErrorModal from "../../components/Error/Error";
import Loading from "../../components/Loading/Loading";
import PhotoGallery from "../../components/PhotoGallery/PhotoGallery";
import PhotoZoom from "../../components/PhotoZoom/PhotoZoom";
import {useData} from "../../context/DataProvider";
import {richTextRenderer} from "../../utils/commonUtil";
import styles from "./IzmiriBGDetay.module.scss";

/* Mock data
const data: IWorkshopItem[] = [
  {
    baslik: "deneme1",
    aciklama:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat null...",
    workshopYil: "2025-01-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel: "/assets/projectYatay.png",

    workshopFotolar: [
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 1,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "d7ffbc3e-b0f5-42b4-54d0-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9059361",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 2,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 3,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 4,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 5,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 6,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 7,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 8,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 9,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 10,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 10,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 10,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
      {
        dosya: "/assets/projectImage.png",
        dosyaTip: "image/jpeg",
        sira: 10,
        workshopId: "2e5a1806-0493-4b9c-c7f0-08dd25a36580",
        id: "92f49870-40d0-4504-54d1-08dd25a36588",
        status: 1,
        createdDate: "2024-12-26T14:49:46.9062648",
        updatedDate: null,
      },
    ],
    id: "5c98ddab-7d04-4697-7f75-08dd266bbbb7",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2075492+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme1.5",
    aciklama: "deneme deneme deneme",
    workshopYil: "2025-01-04T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/f7bba1bc-3193-43fb-95c2-604cec8d47f3.jpg",
    workshopFotolar: [],
    id: "5c98ddab-7d04-4697-7f75-08dd266bbbb7",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2075492+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme2",
    aciklama: "deneme deneme deneme",
    workshopYil: "2024-12-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/f7bba1bc-3193-43fb-95c2-604cec8d47f3.jpg",
    workshopFotolar: [],
    id: "5c98ddab-7d04-4697-7f75-08dd266bbbb8",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2075492+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme3",
    aciklama: "deneme deneme deneme",
    workshopYil: "2024-11-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/f7bba1bc-3193-43fb-95c2-604cec8d47f3.jpg",
    workshopFotolar: [],
    id: "5c98ddab-7d04-4697-7f75-08dd266bbbb9",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2075492+03:00",
    updatedDate: null,
  },
  {
    baslik: "test123",
    aciklama: "dasdasd",
    workshopYil: "2024-09-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/b6eefdbf-f431-4b4d-9278-a94529b39cfd.jpg",
    workshopFotolar: [],
    id: "dcc31c0f-b48d-4123-7f76-08dd266bbbb7",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2111474+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme4",
    aciklama: "deneme deneme deneme",
    workshopYil: "2024-08-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/b6eefdbf-f431-4b4d-9278-a94529b39cfd.jpg",
    workshopFotolar: [],
    id: "dcc31c0f-b48d-4123-7f76-08dd266bbbb7",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2111474+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme5",
    aciklama: "deneme deneme deneme",
    workshopYil: "2024-07-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/b6eefdbf-f431-4b4d-9278-a94529b39cfd.jpg",
    workshopFotolar: [],
    id: "dcc31c0f-b48d-4123-7f76-08dd266bbbb8",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2111474+03:00",
    updatedDate: null,
  },
  {
    baslik: "deneme6",
    aciklama: "deneme deneme deneme",
    workshopYil: "2024-06-06T09:56:11.0345586+03:00",
    kapakGorsel: "/assets/projectKapak.png",
    yatayGorsel:
      "https://localhost:44358/images/Workshop/Yatay/b6eefdbf-f431-4b4d-9278-a94529b39cfd.jpg",
    workshopFotolar: [],
    id: "dcc31c0f-b48d-4123-7f76-08dd266bbbb9",
    status: 1,
    createdDate: "2025-01-09T17:18:12.2111474+03:00",
    updatedDate: null,
  },
];
*/

const IzmiriBGDetay: React.FC = () => {
    const {state} = useLocation();
    const {id,_id} = useParams<{ id: string, _id:string }>();
    const [showZoom, setShowZoom] = useState(false);
    const {workshoplar: data, isLoading, error} = useData();



    if (isLoading) return <Loading/>;
    if (error) return <ErrorModal message={error.message}/>;

    // URL'deki başlığa göre workshop'u bul
    const workshop = data.find(
        (item) => item.baslik === decodeURIComponent(id || "")
    );

    if (!workshop) {
        return <div>Workshop bulunamadı</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.heroImage}
                 style={{
                     height: _id === "34bf5ec5-4fd4-46f9-3d4f-08dda28a49dc" ? "auto" : "600px",
                     width: _id === "34bf5ec5-4fd4-46f9-3d4f-08dda28a49dc" ? "70%" : "100%",
                     margin: _id === "34bf5ec5-4fd4-46f9-3d4f-08dda28a49dc" ? "1rem auto" : "0"
                 }}>
                <img
                    src={workshop.yatayGorsel}
                    alt={workshop.baslik}
                    onClick={() => setShowZoom(true)}
                />
                {showZoom && (
                    <PhotoZoom
                        src={workshop.yatayGorsel}
                        onClose={() => setShowZoom(false)}
                    />
                )}
            </div>

            <div className={styles.content}>
                <h1 className={styles.title}>{workshop.baslik}</h1>

                <div className={styles.description}>
                    {richTextRenderer(workshop?.aciklama || "")}
                </div>

                <PhotoGallery photos={workshop.workshopFotolar}/>
            </div>
        </div>
    );
};

export default IzmiriBGDetay;
